export default "__VITE_ASSET__93c37d68__"